export enum FolderType {
	Insight,
	View,
	Schedule
}

export interface Folder {
	id: string
	title: string
	folderType: FolderType
	teams: string[]
	expanded?: boolean
}
